import PointCutDialog from './pointCutForm.container'

export default PointCutDialog